<app-header-message></app-header-message>
<router-outlet></router-outlet>
@if (showSpinner) {
	<div class="custom-overlay">
		<div class="center">
			<mat-spinner> </mat-spinner>
		</div>
	</div>
}
